"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _text = require("@mmc/text");
var _feefoScoreBadge = _interopRequireDefault(require("./feefo-score-badge.css"));
var FeefoScoreBadge = function FeefoScoreBadge(_ref) {
  var _clsx, _clsx2, _clsx3;
  var _ref$data = _ref.data,
    eyebrowText = _ref$data.eyebrowText,
    headerText = _ref$data.headerText,
    introText = _ref$data.introText,
    background = _ref$data.theme,
    url = _ref$data.url,
    vehicleSkuId = _ref$data.vehicleSkuId,
    disclaimerData = _ref$data.disclaimerData,
    feefoMerchantId = _ref.compProps.feefoMerchantId,
    theme = _ref.theme;
  var isDarkTheme = background === 'dark';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(_feefoScoreBadge["default"].feefoWrapper, (_clsx = {}, _clsx[theme.dark] = isDarkTheme, _clsx[_feefoScoreBadge["default"].backgroundDark] = isDarkTheme, _clsx))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _feefoScoreBadge["default"].flexContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(_feefoScoreBadge["default"].textContent)
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: eyebrowText,
    className: (0, _clsx4["default"])(theme.labelMedium, (_clsx2 = {}, _clsx2[theme.marginBottom20] = headerText || introText, _clsx2))
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: (0, _clsx4["default"])(theme.headingTwo, (_clsx3 = {}, _clsx3[theme.marginBottom20] = introText, _clsx3)),
    text: headerText,
    tag: "h3",
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    className: (0, _clsx4["default"])(theme.bodyCopy, _feefoScoreBadge["default"].introText),
    text: introText,
    tag: "p",
    disclaimerData: disclaimerData
  })), /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    rel: "noreferrer",
    className: (0, _clsx4["default"])(_feefoScoreBadge["default"].imageSection)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Feefo logo",
    border: "0",
    className: _feefoScoreBadge["default"].feefoLogo,
    src: "https://api.feefo.com/api/logo?merchantidentifier=" + feefoMerchantId + "&vendorref=" + vehicleSkuId + "&template=" + (isDarkTheme ? 'Product-Stars-White-316x80.png' : 'Product-Stars-Grey-316x80.png'),
    title: "See what our customers say about this product"
  }))));
};
FeefoScoreBadge.resourceType = function () {
  return 'FeefoScoreBadge_1_0_0';
};
FeefoScoreBadge.displayName = 'FeefoScoreBadge';
var _default = FeefoScoreBadge;
exports["default"] = _default;